module.exports = "https://web-assets.ifttt.com/packs/media/shared/apple-touch-icon-120x120-precomposed-b338b46b.png";